var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26C21.5228 26 26 21.5228 26 16C26 10.4771 21.5228 6 16 6C10.4771 6 6 10.4771 6 16C6 21.5228 10.4771 26 16 26ZM16 24C20.4183 24 24 20.4183 24 16C24 11.5817 20.4183 8 16 8C11.5817 8 8 11.5817 8 16C8 20.4183 11.5817 24 16 24Z",
    fill: "#173261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0841 11.417L12.084 11.4171L11.3487 12.3122C11.175 12.5164 11.0742 12.7848 11.0742 13.0698V19.7365C11.0742 20.3922 11.6102 20.9281 12.2659 20.9281H19.7326C20.3883 20.9281 20.9242 20.3922 20.9242 19.7365V13.0698C20.9242 12.7848 20.8235 12.5162 20.6496 12.312C20.6493 12.3118 20.6491 12.3116 20.6489 12.3113L19.9096 11.4177C19.7423 11.2076 19.4882 11.0781 19.1992 11.0781H12.7992C12.5094 11.0781 12.256 11.2083 12.0841 11.417ZM12.3909 19.6115V13.9948H19.6076V19.6115H12.3909Z",
    fill: "#173261",
    stroke: "#173261",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0712 12.0372H12.9272L12.5006 12.7871H19.5032L19.0712 12.0372Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8243 15.4453V15.3953H18.7743H13.2188H13.1687V15.4453V16.5565V16.6065H13.2188H18.7743H18.8243V16.5565V15.4453Z",
    fill: "#173261",
    stroke: "#173261",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.f097b6f1f86012e0eb42152e8595c2fb.svg";
export { ForwardRef as ReactComponent };